<template>

  <div class="app-message">



  </div>

</template>

<script>
export default {
}
</script>

<style lang="css" scoped>



</style>
